import AudioTracks from "./audioTracks";
import MainContentUpload from "./mainContent";
import SubtitleTracks from "./subtitlesTracks";

const EpisodeUploader = ({ selectedEpisode, updateContent }) => {

    const formattedEpisode = {
        ...selectedEpisode,
        contentId: selectedEpisode.key ?? null,
        contentType: "episode",
    }

    const handleContentUpdate = (content) => {
        updateContent(content)
    }

    return (
        <div>
            <MainContentUpload selectedContent={formattedEpisode} updateContentChild={handleContentUpdate} />
            <div style={{ display: "flex", gap: 40 }}>
                <AudioTracks selectedContent={formattedEpisode} />
                <SubtitleTracks selectedContent={formattedEpisode} />
            </div>
        </div>
    )
}

export default EpisodeUploader;
